/**
 * 会员中心模块api
 */

import request from './request';

// 获取会员列表
export function queryVipList(params) {
    return request('/mms/vip/items', {
        method: 'GET',
        params,
    });
}

// 获取会员等级配置列表
export function queryVipLevelConfigList() {
    return request('/mms/vip/level-config/items', {
        method: 'GET',
    });
}

// 查询会员等级配置详情
export function queryVipLevelConfigDetail(params) {
    return request('/mms/vip/level-config/detail', {
        method: 'GET',
        params,
    });
}

// 创建会员等级配置
export function createVipLevelConfig(params) {
    return request('/mms/vip/level-config', {
        method: 'POST',
        params,
    });
}

// 编辑会员等级配置
export function updateVipLevelConfig(params) {
    return request('/mms/vip/level-config', {
        method: 'PUT',
        params,
    });
}

// 查询会员配置
export function getVipConfig() {
    return request('/mms/vip/level-config/global', {
        method: 'GET',
    });
}

// 编辑会员配置
export function updateVipConfig(params) {
    return request('/mms/vip/level-config/global', {
        method: 'PUT',
        params,
    });
}

// 获取会员权益列表
export function queryVipEquityList(params) {
    return request('/mms/vip/equity-config/items', {
        method: 'GET',
        params,
    });
}

// 获取会员权益详情
export function vipEquityDetail(params) {
    return request('/mms/vip/equity-config/detail', {
        method: 'GET',
        params,
    });
}

// 创建会员权益
export function createVipEquityConfig(params) {
    return request('/mms/vip/equity-config', {
        method: 'POST',
        params,
    });
}

// 编辑会员权益
export function updateVipEquity(params) {
    return request('/mms/vip/equity-config', {
        method: 'PUT',
        params,
    });
}

// 上下架会员权益
export function updateVipEquityStatus(params) {
    return request('/mms/vip/equity-config/status', {
        method: 'PATCH',
        params,
    });
}

// 获取会员任务列表
export function queryVipTaskList(params) {
    return request('/mms/vip/task/items', {
        method: 'GET',
        params,
    });
}

// 获取单个会员的任务列表
export function querySingleVipTaskList(params) {
    return request('/mms/vip/task/person-items', {
        method: 'GET',
        params,
    });
}

// 手动完成会员任务
export function completeVipTask(params) {
    return request('/mms/vip/task/batch-completed', {
        method: 'POST',
        params,
    });
}
// 创建会员任务
export function createVipTask(params) {
    return request('/mms/vip/task', {
        method: 'POST',
        params,
    });
}
// 编辑会员任务
export function editVipTask(params) {
    return request('/mms/vip/task', {
        method: 'PUT',
        params,
    });
}
// 修改会员任务状态
export function editVipTaskStatus(params) {
    return request('/mms/vip/task/status', {
        method: 'PUT',
        params,
    });
}
// 删除会员任务
export function deleteVipTask(id) {
    return request(`/mms/vip/task?id=${id}`, {
        method: 'DELETE',
    });
}

// 标记老会员
export function markOldMember(params) {
    return request('/customer/old-vip', {
        method: 'PATCH',
        params,
    });
}

// 标记新会员
export function markMember(params) {
    return request('/customer/new-vip', {
        method: 'PATCH',
        params,
    });
}
